import client from '../client';
export default {
  getConnectionsList: data => {
    return client.get('seller/cc/connections', { params: data }).then(res => res.data);
  },
  getBrandsList: data => {
    return client.get(`seller/cc/brands/list`, {params:data}).then(res=>res.data);
  },
  getCampaignsList: data => {
    return client.get(`seller/cc/campaigns/list`, {params:data}).then(res=>res.data);
  },
  getCampaignProductsList: data => {
    return client.get(`seller/cc/campaigns/${data.campaignId}/products`, {params:data}).then(res=>res.data);
  },
  getCampaignPublishersList: data => {
    return client.get(`seller/cc/campaigns/${data.campaignId}/publishers`, {params:data}).then(res=>res.data);
  },
  // 创建 Amazon CC 授权申请
  sellerAuthorization: data => {
    return client.post(`seller/cc/authorization`, data).then(res=>res.data);
  },
  // 创建 CC 品牌授权
  sellerBrandAuthorization: data => {
    return client.post(`seller/cc/brands/authorization`, data).then(res=>res.data);
  },
}